import initialState from './initialState';
import { reducer as saveCrashReportReducer } from './saveCrashReport';
import { reducer as loadProjectDetailReducer } from './loadProjectDetail';
import { reducer as loadProjectVersionReducer } from './loadProjectVersion';
import { reducer as toggleDebugModeReducer } from './toggleDebugMode';
import { reducer as loadCollectionChangeReducer } from './loadCollectionChange';
import { reducer as resetCollectionChangeReducer } from './resetCollectionChange';
import { reducer as trackCollectionChangeReducer } from './trackCollectionChange';

const reducers = [saveCrashReportReducer, loadProjectDetailReducer, loadProjectVersionReducer, toggleDebugModeReducer, loadCollectionChangeReducer, resetCollectionChangeReducer, trackCollectionChangeReducer];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}
